// Import model
import { UpdateCustomerRequest } from '../models/UpdateCustomerRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdateSfCustomerRequest } from '../models/UpdateSfCustomerRequest';

// Import dependency serializers (for complex types)
import { UpdateSfCustomerRequestSerializer } from './UpdateSfCustomerRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateCustomerRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateCustomerRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateCustomerRequest instance
   */
  static deserialize(json: string): UpdateCustomerRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateCustomerRequest instance
   */
  static fromObject(obj: any): UpdateCustomerRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateCustomerRequest');
    }


    const instance: UpdateCustomerRequest = {
      isActive: obj['isActive'] as boolean | undefined,
      properties: obj['properties'] ? UpdateSfCustomerRequestSerializer.fromObject(obj['properties']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateCustomerRequest instances
   */
  static deserializeArray(json: string): UpdateCustomerRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateCustomerRequest instance to a JSON string
   */
  static serialize(instance: UpdateCustomerRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateCustomerRequest instance to a plain object
   */
  static toObject(instance: UpdateCustomerRequest): any {
    return {
      'isActive': instance.isActive,
      'properties': instance.properties ? UpdateSfCustomerRequestSerializer.toObject(instance.properties) : undefined,
    };
  }

  /**
   * Serializes an array of UpdateCustomerRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateCustomerRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
